import { WSTimelineItemProps } from "@wingspanhq/fe-component-library";
import type {
  AuditLogResource,
  ListAuditLogsFilterParameterResourceTypeEq
} from "@wingspanhq/wingspan-api-sdk";
import { EventContent } from "./EventContent";
import { EventGroupContent } from "./EventGroupContent";
import { formatActorAvatar, formatActorLabel } from "./formatActor";
import { EventGroup } from "./types";

export function eventGroupToTimeline(
  group: EventGroup,
  drillDownResourceType?: ListAuditLogsFilterParameterResourceTypeEq,
  onDrillDown?: (resource: AuditLogResource) => void
): WSTimelineItemProps {
  if (group.type === "single") {
    return {
      content: (
        <EventContent
          event={group.event}
          drillDownResourceType={drillDownResourceType}
          onDrillDown={onDrillDown}
        />
      ),
      date: group.event.timestamp,
      dateFormat: "default",
      avatar: formatActorAvatar(group.event),
      pills: [formatActorLabel(group.event)]
    };
  }

  return {
    content: (
      <EventGroupContent
        group={group}
        drillDownResourceType={drillDownResourceType}
        onDrillDown={onDrillDown}
      />
    ),
    date: group.anchorTimestamp,
    dateFormat: "default",
    avatar: formatActorAvatar(group.events[0]),
    pills: [group.actor]
  };
}
